import { Dropdown } from "@mui/base/Dropdown";
import { Menu } from "@mui/base/Menu";
import { MenuButton as BaseMenuButton } from "@mui/base/MenuButton";
import { MenuItem as BaseMenuItem } from "@mui/base/MenuItem";
import { styled, keyframes } from "@mui/system";
import { Box } from "@mui/material";
import { ElementType, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const NavigartionDropdownMUI = ({
  items,
  selected,
  isOpen,
  onOpen,
  onClose,
}: {
  items: { label: string; path: string }[];
  selected: string | undefined;
  Icon: ElementType;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}) => {
  const [menuTimeout, setMenuTimeout] = useState<ReturnType<
    typeof setTimeout
  > | null>(null);

  const handleMouseEnter = () => {
    if (menuTimeout) {
      clearTimeout(menuTimeout);
      setMenuTimeout(null);
    }
    onOpen();
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      onClose();
    }, 500);
    setMenuTimeout(timeout);
  };

  const handleItemClick = (path: string) => {
    window.location.href = path;
  };

  return (
    <Dropdown open={isOpen}>
      <MenuButton>
        <Box
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          display="flex"
          alignItems={"center"}
          height={"100px"}
        >
          {selected} <ExpandMoreIcon />
        </Box>
      </MenuButton>
      <Menu
        slots={{ listbox: Listbox }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {items.map((menuItem, index) => (
          <MenuItem key={index} onClick={() => handleItemClick(menuItem.path)}>
            {menuItem.label}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Listbox = styled("ul")(
  ({ theme }) => `
    background-color: #fff;    
    border-radius: 4px;
    border: none;
    display: flex;
    align-items: center;
    transition: all 150ms ease;
    justify-content: center;
    flex-direction: column;
    margin: 0;
    margin-top: -10px;
    padding: 0;
    z-index: 99999;
    animation: ${fadeIn} 150ms ease-out;
    `
);

const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
    list-style: none;
    padding: 8px;
    background-color: #fff;
    width: 100%;
    transition: all 150ms ease;
    cursor: default;
    user-select: none;
    z-index: 99999;
    transition: all 150ms ease;
    border-bottom: 1px solid #dcdcdc; /* Linha cinza */
    &:hover {
      background-color: #ffd200;
      color: #000;
    }
    &:focus {
      outline: none;
      border: none;
    }
    &:last-of-type {
      border-bottom: none; /* Remove gray line from last item */
    }
    `
);

const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    padding: 8px 16px;
    z-index: 99999;
    transition: all 150ms ease;
    cursor: pointer;
    background: none ;
    border: none;
    color: #fff;
    &:focus {
      outline: none;
      border: none;
    }
    `
);
